import { useEffect, useState } from 'react';
import promiseRetry from '../lib/promise-retry';

export const useRetry = ({
  fn = () => {},
  args = {},
  retryOptions = {},
  start = false,
}) => {
  const defaultRetryOption = {
    retries: 3,
    factor: 3,
    minTimeout: 3000,
    randomize: true,
  };
  const [inProgress, setInprogress] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancel = false;
    if (!start) return;
    setInprogress(true);
    promiseRetry(
      function (retry, attempt, operation) {
        // We keep track of `cancel`, for any reason the component gets unmounted, we stop the pending retries.
        if (cancel) {
          operation.stop();
          return;
        }
        return fn(args).catch(retry);
      },
      { ...defaultRetryOption, ...retryOptions }
    ).then(
      (result) => {
        if (cancel) return;
        setInprogress(false);
        setData(result);
      },
      (err) => {
        if (cancel) return;
        setInprogress(false);
        setError(err);
      }
    );
    return () => {
      cancel = true;
      setInprogress(false);
      setData(null);
    };
  }, [start]); // eslint-disable-line react-hooks/exhaustive-deps

  return { inProgress, data, error };
};
